module.exports = __webpack_public_path__ + "player-shake.4a69b683.png";